import React, {useEffect, useState} from 'react';
import '../../../assets/css/report.css';
import {coreStyle} from "../../../styles/config";
import Swal from "sweetalert2";
import axios from "axios";
import {LinearProgress} from '@material-ui/core';
import Translate from "../../../utils/utils";

export default function FlowerInspectionReport(props) {
    const {location: {search}} = props;
    const params = new URLSearchParams(search);
    const inspectionId = params.get('inspectionId');
    let grower = "";
    try {
        grower = window.atob(params.get('grower'));
    } catch (e) {
        grower = "undefined";
    }
    const shipping_date = params.get('shipping_date');
    const [isLoading, setIsLoading] = useState(true);
    const [disabled, setDisabled] = useState(true);

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_BASE_TEST}/report/flower/inspection?inspectionId=${inspectionId}`, {
            responseType: 'arraybuffer',
        }).then(response => {
            setIsLoading(false);
            try {
                const {data} = response;
                const url = URL.createObjectURL(new Blob([data], {
                    type: "application/pdf"
                }));
                const iframe = document.getElementById('pdf');
                const downloadBtn = document.getElementById('download');
                iframe.src = url;
                iframe.setAttribute('name', 'name.pdf');
                downloadBtn.download = `${grower}_${inspectionId}_${shipping_date}.pdf`;
                downloadBtn.href = url;
                setDisabled(false);
            } catch (e) {
                Swal.fire({
                    icon: 'error',
                    text: 'Failed loading report'
                });
            }

        }).catch(() => {
            setIsLoading(false);
            Swal.fire({
                icon: 'error',
                text: 'Failed loading report'
            });
        })
    }, [inspectionId]);

    const printPdf = () => {
        const iframe = document.getElementById('pdf');
        iframe.focus();
        iframe.contentWindow.print();
    }


    return (

        <div className={coreStyle.root}>
            {isLoading && <LinearProgress color="secondary"/>}
            <div className="row pull-right pdf-controls">

                <div className="m-lg-4">
                    <button className="btn btn-success" onClick={printPdf} disabled={disabled}>
                        <i className="fa fa-print"/><Translate id="TABLE.ACTIONS.PRINT"/>
                    </button>
                    &nbsp;
                    <a href="#" download id="download">
                        <button className="btn btn-success" disabled={disabled}>
                            <i className="fa fa-download"/><Translate id="TABLE.ACTIONS.DOWNLOAD"/>
                        </button>
                    </a>
                </div>
            </div>
            <div className="row">
                <div className="pdf">
                    <iframe height="100%" id="pdf"/>
                </div>
            </div>
        </div>
    );

}
